import { useMemo, useState } from 'react';

import { DueDateType } from '../../../db/types';
import { dateTimeDiff, toReadableTime, unix } from '../../../utils/datetime';
import { calculatePercentage } from '../../../utils/math';
import { useInterval } from '../../../utils/timer';
import { usePollContext } from '../Context';
import { getIsPollOpen } from './helpers';

const usePublishedPollRemainingTime = () => {
  const { poll } = usePollContext();

  const [remainingTime, setRemainingTime] = useState(-1);

  const { totalTime, totalTimeReadable } = useMemo(() => {
    if (!poll) return { totalTime: -1, totalTimeReadable: '' };

    const diff = dateTimeDiff(poll.dueDateTime, poll.publishedOn, 'seconds');
    return { totalTime: diff, totalTimeReadable: toReadableTime(diff) };
  }, [poll?.dueDateTime, poll?.publishedOn]);

  const { stop } = useInterval(() => {
    if (!poll) return;

    const isPollManual = poll.preferences.dueDateType === DueDateType.MANUAL;
    if (isPollManual) return;

    const diff = dateTimeDiff(poll.dueDateTime, unix(), 'seconds');
    if (diff >= -1) {
      setRemainingTime(diff);
      return;
    }

    stop();
  }, 1000);

  const remainingPercentage = calculatePercentage(remainingTime, totalTime);

  const remainingTimeReadable = toReadableTime(remainingTime);

  const isPollOpen = getIsPollOpen(poll);

  return {
    remainingTimeInSeconds: remainingTime,
    remainingTimeReadable,
    totalTimeInSeconds: totalTime,
    totalTimeReadable,
    remainingPercentage,
    isPollOpen,
  };
};

export default usePublishedPollRemainingTime;
